import React, { useEffect, useRef } from 'react';
import { StyleSheet, Animated, View } from 'react-native';
import { useTheme } from 'react-native-paper';

import { OEText } from '../../../atoms/oe-text/oe-text';
import { bc, borderColor, flex } from '../../../style-utils';

export interface ProgressBarPopupProps {
  percentage: number;
  barWidth: number;
}

export const ProgressBarPopup: React.FC<ProgressBarPopupProps> = ({
  percentage,
  barWidth,
}) => {
  const { colors } = useTheme();
  const animation = useRef(new Animated.Value(0));

  useEffect(() => {
    if (isNaN(percentage)) {
      return;
    }

    Animated.sequence([
      Animated.delay(300),
      Animated.timing(animation.current, {
        duration: 400,
        toValue: Math.min(percentage, 1),
        useNativeDriver: true,
      }),
    ]).start();
  }, [percentage]);

  return (
    <Animated.View
      style={[
        flex('align-items-center', 'justify-content-center'),
        styles.popup,
        bc(colors.primary),
        {
          transform: [
            {
              translateX: animation.current.interpolate({
                inputRange: [0, 1],
                outputRange: [-20, barWidth - 20],
                extrapolate: 'clamp',
              }),
            },
          ],
        },
      ]}
    >
      <OEText fontSize={11} color={colors.white}>
        {Math.round(percentage * 100)}%
      </OEText>
      <View
        style={[
          styles.triangle,
          bc(colors.transparent),
          borderColor({
            borderLeftColor: colors.transparent,
            borderRightColor: colors.transparent,
            borderTopColor: colors.primary,
          }),
        ]}
      />
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  popup: {
    paddingVertical: 1,
    borderRadius: 4,
    position: 'absolute',
    top: 0,
    left: 0,
    width: 36,
    zIndex: 9,
  },
  triangle: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderLeftWidth: 6,
    borderRightWidth: 6,
    borderTopWidth: 6,
    position: 'absolute',
    bottom: -6,
  },
});
